// success.interceptor.ts
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ToastService } from '../../shared/services/toast.service';

export const successInterceptor: HttpInterceptorFn = (req, next) => {
 const toastService = inject(ToastService);
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const body = event.body as any;
        if (body && typeof body === 'object') {
          if (body && typeof body === 'object' && 'message' in body && body.message ) {
            // toastService.success('Success', body.message, 3000);
          } 
        } 
      }
    })
  );
};



